<template>
  <div class="write-article">
    <h3 class="page-title">写文章</h3>
    <div class="content">
      <el-form
        :model="plan"
        status-icon
        label-width="100px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="标题">
          <el-input type="text" v-model="plan.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input type="text" v-model="plan.intro" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="标题图">
          <el-upload
            action="upImg.php"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :on-remove="delete_file"
            :limit="1"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="内容">
          <script id="editor" type="text/plain"></script>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="upload">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.page-title {
  padding-left: 100px;
  height: 50px;
  line-height: 50px;
  border: 1px solid #f2f2f2;
}
.content {
  width: 1200px;
  height: 700px;
  margin: 20px auto;
}
.input {
  width: 1200px;
  height: 30px;
  font-size: 20px;
  padding: 5px 10px;
  box-sizing: border-box;
  margin: 10px 0;
}
</style>
<script>
export default {
  name: "WriteArticle",
  data() {
    return {
      editor: null,
      title: "",
      intro: "",
      plan: {
        title: null,
        intro: null,
        content: null,
        date: null,
        icon: null
      }
    };
  },
  props: {
    /** 默认文章内容 */
    defaultMsg: {
      type: String
    }
  },
  methods: {
    getUEContent() {
      return this.editor.getContent();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `只能上传 1 张 图片 本次已上传 ${files.length} 张图片`
      );
    },
    handleAvatarSuccess(response, file, fileList) {
      this.plan.icon = response.replace(/\s/g, "");
    },
    delete_file(file, fileList) {
      var self = this;
      var data = {
        path: self.plan.icon
      };
      this.ajax("/upImg.php", "delete", JSON.stringify(data), function(data) {
        /** icon字符设置默认值 */
        self.plan.icon = "";
      });
    },
    upload() {
      var self = this;
      var date = new Date();
      var Y = date.getFullYear();
      var M =
        Number(date.getMonth() + 1) < 10
          ? "0" + Number(date.getMonth() + 1)
          : Number(date.getMonth() + 1);
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var time = Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;

      this.plan.date = time;
      this.plan.content = this.getUEContent();

      $.ajax({
        url: "/plans.php",
        type: "post",
        data: self.plan,
        success: function(data, textStatus, jqXHR) {
          self.$message({
            message: "添加方案成功",
            type: "success"
          });
        }
      });
    }
  },
  /** 创建时，发送指令不显示公用部分头部，尾部，导航栏 */
  created: function() {
    this.$emit("public_header", false);
    this.$emit("public_nav", false);
    this.$emit("public_footer", false);
    const _this = this;
    this.editor = UE.getEditor("editor"); // editor 为script的id名称
    this.editor.addListener("ready", function() {
      _this.editor.setContent(_this.defaultMsg); // 确保UE加载完成后，放入内容。
    });
  },
  destroyed() {
    this.editor.destroy();
  }
};
</script>





// WEBPACK FOOTER //
// src/components/writePlan.vue